export default {
    path: 's2journal',
    name: 'jcrScopusForm',
    component(){
        return import('@/components/s2journal/JcrScopusForm.vue');
    },
    children:[
        {
            path:'',
            name:'jcrScopusList',
            component() {
                return import('@/components/s2journal/JCRScopusList.vue');
            }
        }
    ]
}